<template>
  <div class="page">
    <Header title="购物车" rightText="编辑" :rightHandler="toEdit" fixed v-show="!isEdit" />
    <Header title="购物车" rightText="完成" :rightHandler="toEdit" fixed v-show="isEdit" />
    <div class="padding-bottom-3">
      <div class="cart-list" v-for="(itemInfo, index) in cartList" :key="index">
        <van-swipe-cell>
          <div class="cart-list-item">
            <van-checkbox checked-color="#e20015" v-model="itemInfo.selected" ref="checkbox" :name="itemInfo"
              @click="cartItemCheck(itemInfo)" :disabled="checkDisable(itemInfo)" class="van-checkbox">
            </van-checkbox>
            <div class="order-item">
              <van-image class="order-item-img" :src="(filePrefix + itemInfo.itemImageUri)"></van-image>
              <div class="order-item-info">
                <p class="van-multi-ellipsis--l2">礼品名称：{{ itemInfo.itemName }}</p>
                <div class="order-item-sort colo333">
                  <div class="order-item-name" v-for="subItemLink in itemInfo.subItemLinkList"
                    :key="subItemLink.linkId">
                    礼品：{{ subItemLink.subItem.itemName }}</div>
                  <div class="themecolor" v-if="itemInfo.mOQMultiple === undefined && itemInfo.mOQ !== undefined">
                    最小起订量：{{ itemInfo.mOQ }}</div>
                  <div class="themecolor" v-if="itemInfo.mOQMultiple !== undefined && itemInfo.mOQ === undefined">
                    最小起订倍数：{{ itemInfo.mOQMultiple }}</div>
                  <div class="themecolor" v-if="itemInfo.mOQMultiple !== undefined && itemInfo.mOQ !== undefined">
                    最小起订倍数：{{ itemInfo.mOQMultiple }}</div>
                </div>
                <div>
                  <div class="order-item-sort van-multi-ellipsis--l2">
                    <p>订购人：<span>{{ itemInfo.userName
                    }}({{itemInfo.userRoleName}})</span></p>
                    <p>&#12288;&#12288;&#12288;&#12288;{{itemInfo.userMobile}}</p>
                  </div>
                  <div class="order-item-value">
                    <p class="point-name"> {{ itemInfo.pointTypeName }} <span
                        v-if="itemInfo && itemInfo.isSpecial == 1">(特殊)</span>：
                      <span style="font-size:0.3rem;">{{ itemInfo.exchangePoint }} </span>
                    </p>
                    <span v-if="!isEdit">×{{ itemInfo.itemQuantity }}</span>
                    <van-stepper @click.stop v-if="isEdit" v-model="itemInfo.itemQuantity"
                      :max="(itemInfo.parentCategoryCode === '1032') ||(itemInfo.itemCategoryCode === '13003') || (itemInfo.itemCategoryCode === '501')? 1 : 9999"
                      :disabled="itemInfo.publishStatus === 0 || itemInfo.activeStatus === 0"
                      @change="change(itemInfo, $event)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template #right>
            <van-button square text="删除" type="danger" class="delete-button" @click="cartItemDelete(itemInfo)" />
          </template>
        </van-swipe-cell>
      </div>
      <div class="text-center no-message" v-if="!cartList.length">暂无更多信息</div>
    </div>
    <div class="fixed">
      <van-checkbox class="van-checkbox" checked-color="#e20015" v-model="checkedAll" name="all"
        @click="changeAllCheck">全选</van-checkbox>
      <div class="flex-right" v-show="!isEdit">
        <p class="total">合计:</p>
        <div class="total-point">
          <p v-for="item in settlementPointList" :key="item.pointType">{{ item.pointTypeName }} :{{ item.pointValue }}
          </p>
        </div>
        <van-button type="primary" size="large" v-if="this.userRole !== '03'" :disabled="checkVerifyStatus"
          @click="getSettlementInfo">去结算
        </van-button>
      </div>
      <div class="flex-right" v-show="isEdit">
        <van-button type="primary" size="large" @click="cartItemDelete()">删除
        </van-button>
      </div>
    </div>
    <tabbar :active="2"></tabbar>
  </div>
</template>

<script>
import Header from '@/components/header'
import { mapState } from 'vuex'
import Tabbar from '../../components/tabbar.vue'
import cartApi from '@/api/cart'
import baseApi from '@/api/base'
import { commonUtils } from '@/utils/common'
export default {
  components: {
    Tabbar,
    Header
  },
  data () {
    return {
      userStatus: -1,
      cartList: [],
      checkedAll: false, // 全选按钮
      isEdit: false,
      // pointList: [],
      settlementPointList: [{
        pointTypeName: '易加积分',
        pointType: '1',
        pointValue: 0
      }, {
        pointTypeName: 'POS积分',
        pointType: '2',
        pointValue: 0
      }],
      selectList: [], // 选中列表
      knowledageChecked: false,
      unknowledageChecked: false
    }
  },
  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl,
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    }),
    checkVerifyStatus () {
      return this.clientInfo.verifyStatus === '01'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getClientInfo()
    },
    // 客户信息获取
    getClientInfo () {
      /*
        isActivated:int, //0未激活 1已激活
        clientStatus:string, //客户状态 01创建 02活跃 03冻结
        verifyStatus:string, //审核状态 01待审核 02已审核
        */
      const { isActivated, clientStatus, verifyStatus } = this.clientInfo
      if (isActivated === 1 && clientStatus !== '03' && verifyStatus === '01') {
        this.userStatus = 1
      } else if (isActivated === 1 && clientStatus !== '03' && verifyStatus === '02') {
        this.userStatus = 2
      }
      if (this.clientInfo) {
        this.getCartList()
        // this.getPoint()
      }
    },
    // 购物车列表
    getCartList () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      cartApi.getCartList().then(res => {
        if (res.data.resultCode === '0') {
          const { cartList } = res.data.resultData
          this.cartList = cartList || []
          this.selectList = []
          let knowledageNum = 0
          let unknowledageNum = 0
          this.cartList.forEach(e => {
            if (e.selected) {
              if (e.itemCategoryCode === '501') {
                this.knowledageChecked = true
                this.unknowledageChecked = false
              } else {
                this.knowledageChecked = false
                this.unknowledageChecked = true
              }

              this.selectList.push(e)
            }
          })
          if (this.knowledageChecked) {
            this.cartList.forEach(row => {
              if (row.itemCategoryCode === '501') {
                knowledageNum++
              }
            })
            this.checkedAll = knowledageNum === this.selectList.length
          } else if (this.unknowledageChecked) {
            this.cartList.forEach(row => {
              if (row.itemCategoryCode !== '501') {
                unknowledageNum++
              }
            })
            this.checkedAll = unknowledageNum === this.selectList.length
          }
          this.calculation()
        }
        this.$toast.clear()
      }).catch(() => { this.$toast.clear() })
    },
    // 积分列表
    getPoint () {
      baseApi.getPointList().then(res => {
        if (res.data.resultCode === '0') {
          this.pointList = res.data.resultData.pointList
          for (let item in this.pointList) {
            this.settlementPointList.push({
              pointTypeName: this.pointList[item].pointTypeName,
              pointType: this.pointList[item].pointType,
              pointValue: 0
            })
          }
        }
      })
    },
    checkDisable (item) {
      if (this.knowledageChecked && item.itemCategoryCode !== '501') {
        return true
      }

      if (this.unknowledageChecked && item.itemCategoryCode === '501') {
        return true
      }
    },
    // 商品checkbox
    cartItemCheck (item) {
      let needUpdate = true
      this.$refs.checkbox.some(row => {
        if (row.name.itemId === item.itemId && row.disabled) {
          needUpdate = false
        }
      })
      if (!needUpdate) {
        return
      }
      if (item.selected) {
        this.selectList.push(item)
        if (item.itemCategoryCode === '501') {
          this.knowledageChecked = true
          this.unknowledageChecked = false
        } else {
          this.knowledageChecked = false
          this.unknowledageChecked = true
        }
      } else {
        const index = this.selectList.findIndex(e => {
          return e.itemId === item.itemId
        })
        if (index !== -1) {
          this.selectList.splice(index, 1)
        }
        this.undisable(item)
      }
      this.calculation()
      this.updateCheck(item)
    },
    undisable (item) {
      let checked = false
      this.cartList.forEach(row => {
        if (row.selected) {
          if (row.itemCategoryCode === '501') {
            this.knowledageChecked = true
            this.unknowledageChecked = false
            checked = true
          } else {
            this.knowledageChecked = false
            this.unknowledageChecked = true
            checked = true
          }
        }
      })

      if (!checked) {
        this.knowledageChecked = false
        this.unknowledageChecked = false
      }
    },

    // 进步器变化
    change (item, value) {
      if (value) {
        this.update(item.itemId, value, item.cartId)
        this.calculation()
      }
    },
    // 购物车修改礼品数量
    update (itemId, num, cartId) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      let data = {
        itemId: itemId,
        itemQuantity: num,
        cartId: cartId
      }
      cartApi.updateCar(data).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
        } else if (res.data.resultCode === '01') {
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 检查所有按钮状态
    updateCheck (item) {
      let knowledageNum = 0
      let unknowledageNum = 0
      if (!item.selected) {
        this.checkedAll = false
      } else {
        if (this.knowledageChecked) {
          this.cartList.forEach(row => {
            if (row.itemCategoryCode === '501') {
              knowledageNum++
            }
          })
          this.checkedAll = knowledageNum === this.selectList.length
        } else if (this.unknowledageChecked) {
          this.cartList.forEach(row => {
            if (row.itemCategoryCode !== '501') {
              unknowledageNum++
            }
          })
          this.checkedAll = unknowledageNum === this.selectList.length
        }
      }

      this.calculation()
    },
    // 全选按钮
    changeAllCheck () {
      if (this.checkedAll) {
        this.calcuateAllCheck()
        const list = this.cartList.filter(row => row.selected)
        this.selectList = list
      } else {
        this.cartList.forEach(e => {
          e.selected = 0
        })
        this.unknowledageChecked = false
        this.knowledageChecked = false
        this.selectList = []
      }
      this.calculation()
    },
    calcuateAllCheck () {
      let knowledgeNum = 0
      this.cartList.forEach(e => {
        if (e.itemCategoryCode === '501') {
          knowledgeNum++
        }
      })
      this.cartList.forEach(e => {
        if (knowledgeNum === this.cartList.length) {
          this.knowledageChecked = true
          this.unknowledageChecked = false
          e.selected = 1
        } else {
          if (knowledgeNum !== 0) {
            this.$toast('课程类礼品不能同常规类礼品批量操作')
          }
          if (e.itemCategoryCode !== '501') {
            e.selected = 1
            this.knowledageChecked = false
            this.unknowledageChecked = true
          } else {
            e.selected = 0
          }
        }
      })
      this.checkedAll = true
    },
    // 计算积分
    calculation () {
      for (let item in this.settlementPointList) {
        this.settlementPointList[item].pointValue = 0
      }
      for (let item in this.selectList) {
        console.log(this.selectList, 'this.selectList')
        for (let item2 in this.settlementPointList) {
          if (this.selectList[item].pointType === this.settlementPointList[item2].pointType) {
            this.settlementPointList[item2].pointValue += this.selectList[item].itemQuantity * this.selectList[item].exchangePoint
          }
        }
      }
    },
    // 左滑删除
    cartItemDelete (item) {
      let data = []
      if (this.selectList.length === 0) {
        this.$toast('您还没有选择任何礼品')
      } else {
        this.$dialog.confirm({
          title: '提示',
          message: '是否删除所选择的礼品'
        }).then(() => {
          if (item) {
            data.push({ itemId: item.itemId, cartId: item.cartId })
          } else {
            const list = this.cartList.filter(row => row.selected)
            list.forEach(e => { data.push({ itemId: e.itemId, cartId: e.cartId }) })
          }
          cartApi.removeCart(data).then(res => {
            if (res.data.resultCode === '0') {
              this.getCartList()
              this.unknowledageChecked = false
              this.checkedAll = false
              this.knowledageChecked = false
            }
          })
        }).catch(() => { })
      }
    },
    // 去结算
    getSettlementInfo () {
      if (this.userStatus === 1) {
        this.$toast('账号待审核')
        return
      }
      let hasSpecial = false
      let hasNormal = false
      let hasonline = false
      let hasOthers = false
      let hasOffline = false
      let hasOther = false
      let nowTime = commonUtils.parseTime(new Date(), '{y}-{m}-{d}')
      for (let item in this.selectList) {
        if (this.selectList[item].publishStatus === 0 || this.selectList[item].activeStatus === 0) {
          this.$toast('存在已下架或被删除的礼品,无法下单')
          return
        }
        if (this.selectList[item].usableStock === 0) {
          if (!!this.selectList[item].isPreOrder && this.selectList[item].isPreOrder === 0) {
            this.$toast('存在数量为0的礼品,且该商品不可预订,无法下单')
            return
          }
        }
        if (this.selectList[item].itemCategoryCode === '1031' && this.selectList[item].cutoffTime) {
          let cutoffTime = commonUtils.parseTime(this.selectList[item].cutoffTime, '{y}-{m}-{d}')
          let isCut = commonUtils.compareDate(cutoffTime, nowTime, 1)
          if (isCut) {
            this.$toast(this.selectList[item].itemName + '报名已截止')
            return
          }
          hasOffline = true
        } else {
          hasOther = true
        }
        if (this.selectList[item].isSpecial === 1) {
          hasSpecial = true
        }
        if (this.selectList[item].isSpecial === 0) {
          hasNormal = true
        }
        if ((this.selectList[item].parentCategoryCode && this.selectList[item].parentCategoryCode === '1032') || (this.selectList[item].itemCategoryCode && this.selectList[item].itemCategoryCode === '13003')) {
          hasonline = true
        } else {
          hasOthers = true
        }
      }
      if (hasOffline && hasOther) {
        this.$toast('线下课程,只能单独下单')
        return
      }
      if (hasSpecial === true && hasNormal === true) {
        this.$toast('特殊积分礼品,只能单独下单')
        return
      }
      if (hasonline && hasOthers) {
        this.$toast('线上课程,只能单独下单')
        return
      }
      if (hasonline && this.selectList.length > 1) {
        this.$toast('线上课程，一次只能购买一个')
        return
      }
      if (this.selectList.length === 0) {
        this.$toast('您还没有选择任何礼品,无法下单')
        return
      }
      let paramsList = []
      for (var item in this.selectList) {
        paramsList.push({
          selected: 1,
          itemId: this.selectList[item].itemId,
          cartId: this.selectList[item].cartId
        })
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      cartApi.checkSettlement(paramsList).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.$router.push({
            name: 'orderCreate'
          })
        }
      }).catch(() => { this.$toast.clear() })
    },
    toEdit () {
      // this.isEdit = !this.isEdit
      if (this.cartList.length === 0 && !this.isEdit) {
        this.$toast('购物车没有任何礼品,无法编辑')
      } else {
        this.isEdit = !this.isEdit
      }
    }
  }
}
</script>
<style  scoped lang="less">
.cart-list {
  padding: 0rem 0.3rem;

  .delete-button {
    height: 100%;
  }
}

.cart-list-item {
  display: flex;
  align-items: center;
  margin: 0.2rem 0rem;
}

.order-item {
  display: flex;
  align-items: stretch;
  color: var(--base-green);
  font-size: 0.35rem;
  height: 100%;
  min-height: 1.8rem;
  width: 100%;

  .order-item-img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.3rem;
    flex-shrink: 0;
  }

  .order-item-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1 0%;

    .order-item-sort {
      color: #333;
    }

    .order-item-value {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .point-name {
        color: #e20015;

        span {
          font-size: 0.4rem;
        }
      }
    }
  }
}

.fixed {
  bottom: 1.3rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding-left: 0.2rem;
  box-sizing: border-box;
  height: 1.5rem;

  .flex-right {
    display: flex;
    align-items: center;

    .total {
      font-size: 0.35rem;
      white-space: nowrap;
    }

    .total-point {
      font-size: 0.35rem;

      white-space: nowrap;
      color: #e20015;

      p {
        margin: 0.2rem;
      }

      p:first-child {
        color: var(--base-green);
      }
    }

    button {
      width: 3rem;
      height: 100%;
    }
  }
}

.rightText {
  color: #fff;
}

.padding-bottom-3 {
  padding-bottom: 2.8rem;
}

.van-checkbox {
  overflow: inherit;
  margin: 0rem 0.4rem 0rem 0rem;

  /deep/ .van-checkbox__icon--disabled .van-icon {
    border: 1px solid #c5c9cd
  }

  /deep/ .van-icon {
    border: 1px solid #e20015
  }

  /deep/ .van-checkbox__icon--checked .van-icon {
    border: 1px solid #e20015;
  }
}

.no-message {
  margin-top: 0.5rem;
  color: #999
}
</style>
